<div id="top-of-page"></div>
<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<!-- Header: titolo + azione primaria della schermata, come la riga
     "titolo + Nuova" delle tabelle bozze/preventivi/documenti. -->
<div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
  <div>
    <h3 class="m-0">Porta un amico</h3>
    <p class="m-0 text-muted">
      Con <strong>Beizy</strong> l'unione fa la forza: ti aggiorniamo noi quando il tuo bonus è pronto.
    </p>
  </div>

  <div class="hidden-mobile">
    <button
      matButton="filled"
      type="button"
      (click)="openNewReferralDialog()"
      matTooltip="Presenta una nuova Partita IVA a Beizy."
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
      class="flex-shrink-0 izy-button-primary custom-button-border"
    >
      <mat-icon>add</mat-icon>
      Nuova richiesta
    </button>
  </div>
</div>

<!-- Mobile: azione primaria a piena larghezza -->
<div class="visible-mobile mt-2 w-100 mb-3">
  <button
    matButton="filled"
    type="button"
    (click)="openNewReferralDialog()"
    class="w-100 izy-button-primary custom-button-border"
  >
    <mat-icon>add</mat-icon>
    Nuova richiesta
  </button>
</div>

<!-- Card informativa: rimanda alle linee guida su beizy.it. Superficie piatta
     bianca con bordo nero 2px e angolo basso-sinistra vivo, come le card
     documento/notifica. -->
<mat-card class="info-card izy-sharp-bl custom-card-border mb-3">
  <mat-card-content class="info-card-content">
    <div class="info-card-text">
      <span class="izy-corner-icon">
        <mat-icon>help</mat-icon>
      </span>
      <div>
        <h6 class="m-0">Come funzionano le richieste?</h6>
        <p class="m-0 text-muted small">
          Invita una Partita IVA: otterrete entrambi un bonus.
        </p>
      </div>
    </div>

    <button
      mat-stroked-button
      type="button"
      (click)="redirectToPortaUnAmico()"
      matTooltip="Apri le linee guida su beizy.it."
      [matTooltipShowDelay]="showDelay.value"
      [matTooltipHideDelay]="hideDelay.value"
      class="flex-shrink-0 izy-button-ghost custom-button-border"
    >
      <mat-icon>explore</mat-icon>
      <span class="hidden-mobile">Leggi le linee guida</span>
      <span class="visible-mobile">Linee guida</span>
    </button>
  </mat-card-content>
</mat-card>

<!-- Titolo della sezione + contatore delle richieste, come il contatore dei
     filtri attivi delle tabelle (pillola bordata). -->
<div class="d-flex justify-content-between align-items-center mt-3 mb-2 ms-1 w-100">
  <h5 class="m-0">Richieste attive</h5>
  <span
    *ngIf="!isLoading && allReferralRequests.length > 0"
    class="request-count"
  >
    {{ allReferralRequests.length }}
  </span>
</div>

<!-- Loading State -->
<ng-container *ngIf="isLoading; else contentTemplate">
  <div class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricamento in corso...</p>
  </div>
</ng-container>

<ng-template #contentTemplate>
  <!-- Empty State: stessa impaginazione degli altri elenchi (icona opaca,
       titolo, riga di spiegazione). -->
  <ng-container *ngIf="allReferralRequests.length === 0; else requestsTemplate">
    <div class="empty-container">
      <mat-icon>groups</mat-icon>
      <h3>Nessuna richiesta trovata...</h3>
      <p>Invita una Partita IVA ed entrambi otterrete un bonus!</p>
      <button
        mat-stroked-button
        type="button"
        (click)="redirectToPortaUnAmico()"
        class="mt-2 izy-button-ghost custom-button-border"
      >
        <mat-icon>explore</mat-icon>
        Leggi le linee guida
      </button>
    </div>
  </ng-container>

  <!-- Elenco richieste -->
  <ng-template #requestsTemplate>
    <div class="requests-list">
      <mat-card
        *ngFor="let request of allReferralRequests"
        class="referral-card izy-sharp-bl custom-card-border"
      >
        <mat-card-content class="referral-content">
          <h6 class="referral-name">{{ request.name }}</h6>
          <p class="referral-meta mb-0">
            <mat-icon class="referral-meta-icon me-1">mail</mat-icon>
            {{ request.mail }}
          </p>
          <p *ngIf="request.telephone" class="referral-meta mb-0">
            <mat-icon class="referral-meta-icon me-1">call</mat-icon>
            {{ request.telephone }}
          </p>
        </mat-card-content>

        <!-- Il footer e' l'unica zona panna della card: lo stato a sinistra,
             il comando a destra, separati dal contenuto dal tratto nero 2px
             (come le card bozza e documento). -->
        <div class="d-flex justify-content-between align-items-center referral-card-footer">
          <mat-chip
            class="ms-2 status-chip"
            [ngClass]="getStatusChipClass(request.status)"
          >
            {{ getReferralTypeDisplay(request.status) }}
          </mat-chip>

          <button
            mat-stroked-button
            type="button"
            (click)="openReferralDetailsDialog(request)"
            matTooltip="Apri i dettagli della richiesta."
            [matTooltipShowDelay]="showDelay.value"
            [matTooltipHideDelay]="hideDelay.value"
            class="me-2 referral-details-btn custom-button-border"
          >
            <mat-icon>visibility</mat-icon>
            Visualizza
          </button>
        </div>
      </mat-card>
    </div>
  </ng-template>
</ng-template>

<div class="pt-3 mb-3"></div>
